interface setSignPlatform{
  title: string;
}

export const setPlatform=(signPlatform:setSignPlatform)=>({
 type: 'SET_PLAT_FORM',
 signPlatform,
})